(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.ramqSearchSubmit = {
    attach: function (context) {
      $(".form-item-js-button", context)
        .children(".btn")
        .click(function (event) {
          event.preventDefault();
          $(this)
            .closest("form")
            .trigger("submit");
        });
    }
  };

  // autosubmit for medicaments search.
  Drupal.behaviors.ramqSearchAutoSubmit = {
    attach: function (context) {
      $("#ui-id-2").on("click", function (event) {
        $("#edit-submit-recherche-medicaments-page").trigger("click");
      });
    }
  };

  // Handlers for toggle buttons
  /* @todo revue de code */
  Drupal.behaviors.ramqSearchbarToggle = {
    attach: function (context) {
      $(".searchbar-toggler").on("click", function (event) {
        if ($(".searchbar-toggler").hasClass("collapsed")) {
          $(".searchbar-toggler .open-text").attr("hidden", true);
          $(".searchbar-toggler .close-text").attr("hidden", false);
        } else {
          $(".searchbar-toggler .close-text").attr("hidden", true);
          $(".searchbar-toggler .open-text").attr("hidden", false);
        }
      });

      $(".navbar-toggler").on("click", function (event) {
        if ($(".navbar-toggler").hasClass("collapsed")) {
          $(".navbar-toggler .close-text").attr("hidden", true);
          $(".navbar-toggler .open-text").attr("hidden", false);
          $(".page").removeClass("menu_page");
        } else {
          $(".navbar-toggler .open-text").attr("hidden", true);
          $(".navbar-toggler .close-text").attr("hidden", false);
          $(".page").addClass("menu_page");
        }
      });

      $(".form-item-js-button", context)
        .children("a")
        .on("click", function (event) {
          event.preventDefault();
          $(this)
            .closest("form")
            .trigger("submit");
        });
    }
  };

  /**
   * Ajouter l'icone et le texte hors écran pour un lien interne qu'on ouvre dans un nouvel onglet
   */
  Drupal.behaviors.liensInternesNouvelOnglet = {
    attach: function (context, settings) {
      var $links_to_process;

      $(".info-utiles-liens-externes, .wp-block-group")
        .find("a[target='_blank']:not(.ext)")
        .each(function () {
          $(this)
            .once()
            .append(
              '<img alt="" class="icone lien_externe-icone" src="/themes/custom/ramq/assets/images/lien_externe.svg">'
              + '<span class="sr-only">&nbsp;' + Drupal.t("This link will open in a new window.") + '</span>'
            );
        });
    }
  };

  /**
   * Apply a class and a trailing <span> to all links not containing images.
   *
   * @param {object[]} links
   *   An array of DOM elements representing the links.
   * @param {string} class_name
   *   The class to apply to the links.
   */
  Drupal.extlink.applyClassAndSpan = function (links, class_name) {
    var $links_to_process;

    if (drupalSettings.data.extlink.extImgClass) {
      $links_to_process = $(links);
    } else {
      var links_with_images = $(links)
        .find("img")
        .parents("a");
      $links_to_process = $(links).not(links_with_images);
    }
    if (class_name !== "0") {
      $links_to_process.addClass(class_name);
    }
    var i;
    var length = $links_to_process.length;
    for (i = 0; i < length; i++) {
      var $link = $($links_to_process[i]);

      $link.append(
        '<img alt="" class="icone lien_externe-icone" src="/themes/custom/ramq/assets/images/lien_externe.svg"><span class="sr-only">&nbsp;' +
        Drupal.t("This link will open in a new window.") +
        "</span>"
      );
    }
  };

  /**
   * Changer l'icone d'un lien externe selon la couleur de la police de l'hyperlien
   */
  Drupal.behaviors.changerCouleurIconesLienExterne = {
    attach: function (context, settings) {
      $("header, main, footer")
        .find("a[target='_blank']")
        .each(function () {
          var couleurPolice = $(this).css("color");
          switch (couleurPolice) {
            //Si police de couleur $bleu-dark #223654
            case "rgb(34, 54, 84)":
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe_dark.svg");
              break;
            //Si police de couleur $bleu-hover #3270C8
            case "rgb(50, 112, 200)":
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe_bleu_hover.svg");
              break;
            //Si police de couleur $orange-brown #B25031
            case "rgb(178, 80, 49)":
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe_orange.svg");
              break;
            //Si police de couleur $white #FFFFFF
            case "rgb(255, 255, 255)":
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe_blanc.svg");
              break;
            //Si police de couleur $black #000000
            case "rgb(0, 0, 0)":
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe_noir.svg");
              break;
            //Si police de couleur $blue-disabled #6E7787
            case "rgb(110, 119, 135)":
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe_desactive.svg");
              break;
            default:
              $(this).find("img.lien_externe-icone").once().attr("src", "/themes/custom/ramq/assets/images/lien_externe.svg");
          }
        });
    }
  }

  /**
   * Back to top links
   */
  Drupal.behaviors.backtotop = {
    attach: function (context, settings) {
      var exist = $("#backtotop").length;
      if (exist == 0) {
        $("body", context)
          .once("backtotop")
          .each(function () {
            $("body").append(
              "<a href='#main-content' id='backtotop' class='back-to-top-js'><span class='sr-only'>" +
              Drupal.t("Back to top") +
              "</span></a>"
            );
          });
      }

      backToTop();
      $(window).on("scroll", function () {
        backToTop();
      });

      $("#backtotop", context)
        .once("backtotop")
        .each(function () {
          $(this).on("click", function () {
            scrollTopTop();
            return false;
          });
          $(this).on("keyup", function (event) {
            if (event.keyCode === 13) {
              //event.preventDefault();
              scrollTopTop();
              return false;
            }
          });
        });

      function scrollTopTop() {
        $("html, body").bind(
          "scroll mousedown DOMMouseScroll mousewheel keyup",
          function () {
            $("html, body").stop();
          }
        );
        $("html,body").animate({
          scrollTop: 0
        },
          "easeOutQuart",
          function () {
            $("html, body").unbind(
              "scroll mousedown DOMMouseScroll mousewheel keyup"
            );
            $('a[href="#main-content"]:not([id="backtotop"])').trigger("focus");
          }
        );
      }

      /**
       * Hide show back to top links.
       */
      function backToTop() {
        if (
          $(window).scrollTop() >
          settings.back_to_top.back_to_top_button_trigger
        ) {
          $("#backtotop").fadeIn();
        } else {
          $("#backtotop").fadeOut();
        }
      }
    }
  };

  /**
   * Anchor links
   */
  /* @todo revue de code */
  Drupal.behaviors.ramqLiensAncres = {
    attach: function (context) {
      $('a[href^="#"]', context)
        .once()
        .click(function (event) {
          event.preventDefault();
          var target = $(this).attr("href");
          if (target === "#" || $(this).attr("id") === "backtotop")
            return false;
          scrollToAnchor(target);
          return false;
        });

      function scrollToAnchor(target) {
        // Le target est l'élément vers lequel on scroll
        // Le target_focus est l'élément sur lequel on met le focus
        var target_focus = target;

        if (
          typeof $(target)[0] != 'undefined' && (
            $(target)[0].nodeName == "INPUT" ||
            ($(target)[0].nodeName == "DIV" &&
              $(target)
                .parents()
                .hasClass("webform")))
        ) {

          //Pour les pièces à joindre
          if ($(target).hasClass("js-form-managed-file")) {
            target_focus = $(target).children("input.webform-file-button-input");
            target = $(target).parents("div[id^=ajax-wrapper]");

          } else if (!$(target).hasClass("form-item--error")) {

            var label_target = $("label[for=" + target.replace("#", "") + "]");
            if (label_target.length != 1 || !label_target.is(":visible")) {
              target = $(target).closest("fieldset");
            } else {
              target = $(target).closest(".form-item--error");
            }

          }
        }

        if ($(target).is('[class*="radios"]') || $(target).is('[class*="checkboxes"]')) {
          target_focus = $(target).find("input").first();
        }

        if (target == "#main-content") {
          target_focus = "#main-content-focus";
        }

        $("html, body").bind(
          "scroll mousedown DOMMouseScroll mousewheel keyup",
          function (event) {
            if (event.type !== "keyup" || event.which !== 13)
              $("html, body").stop();
          }
        );

        if (typeof $(target).offset() !== 'undefined'){
          $("html,body").animate({
            scrollTop: $(target).offset().top
          },
            1200,
            "easeOutQuart",
            function () {
              $("html, body").unbind(
                "scroll mousedown DOMMouseScroll mousewheel keyup"
              );
            }
          );
        }

        $(target_focus).trigger("focus").addClass("focus-visible");

        //Si le target est un accordéom
        if (
          $(target)
            .parents()
            .hasClass("wp-block-accordion-accordion-block")
        ) {
          $(target)
            .children("button")
            .trigger("click");
        }
      }

      $('input[type="file"]', context).on("focus focusout", function (event) {
        var fileBtn = $(this)
          .parent()
          .find("label.webform-file-button")
          .first();
        switch (event.type) {
          case "focus":
            fileBtn.addClass("focus-visible");
            break;
          case "focusout":
            fileBtn.removeClass("focus-visible");
            break;
        }
      });

      $(context)
        .find('#recapitulatif-erreurs')
        .once("DeposerFocusSurEncadreDesErreurs")
        .each(function () {
          if (
            !!!$(context).has(
              'input[type="checkbox"]:checked, input[type="radio"]:checked'
            ).length &&
            $(this).has('a[href^="#"]').length
          ) {
            $(this)
              .attr("tabindex", "-1")
              .trigger("focus");
          }
        });
    }
  };

  /* Ajout de textes hors écran pour l'accessibilité */
  /* @todo revue de code */
  Drupal.behaviors.ramqSrOnlyText = {
    attach: function (context) {
      /* Textes hors écran pour les types d'encadrés */
      var elementsType = {
        ".encadre-important": Drupal.t("Important information"),
        ".encadre_information-majeure": Drupal.t("Important information"),
        ".encadre_information-mineure": Drupal.t("Practical information"),
        ".encadre_information-discrete": Drupal.t("Additional information")
      };

      $.each(elementsType, function (key, value) {
        $(key)
          .once()
          .each(function () {
            var encadre_title = "<span class='sr-only'>" + value + "</span>";
            $(this)
              .children(".wp-block-group__inner-container")
              .prepend(encadre_title);
          });
      });

      /* Entêtes hors écran pour les types de listes */
      var listesType = {
        ".bloc_voir-aussi .liste-lien-page": Drupal.t("Related pages"),
        ".bloc_voir-aussi .liste-lien-page-doc": Drupal.t("Related documents")
      };

      $.each(listesType, function (key, value) {
        $(key)
          .once()
          .each(function () {
            var liste_title = "<p class='sr-only'>" + value + "</p>";
            $(liste_title).insertBefore(this);
          });
      });
    }
  };

  // Hide pagination footer when there are less than 10 results available in small screen.
  Drupal.behaviors.pagerNavigationFooter = {
    attach: function (context) {
      if ($(".pager-navigation-footer").length != 0) {
        if ($("nav.pagination-nav").length == 0) {
          $(".recherche-medicaments-bloc, .resultats-de-recherche-page, .liste-formulaire-pdf-pro")
            .find("footer")
            .hide();
        }
      }
    }
  };

  /* Design - Vérifier si le bloc Voir aussi existe dans la page pour ajuster la marge
   ** entre pied de page et contenu */
  Drupal.behaviors.ramqVerifierVoirAussi = {
    attach: function (context) {
      if ($(".bloc_voir-aussi").length != 0) {
        if ($(".recherche-medicaments-bloc").length != 0) {
          $(".recherche-medicaments-bloc").addClass("marge-mini");
        } else {
          if ($(".node--type-communiques").length != 0) {
            $(".node--type-communiques")
              .children(".container")
              .addClass("marge-mini");
          } else {
            $(".contenu-page").addClass("marge-mini");
          }
        }
      }

      if ($(".voir-aussi-eva.view-actualite-communiques-info").length != 0) {
        $(".node--type-communiques")
          .children(".container")
          .addClass("marge-mini");
        $(".node--type-article")
          .children(".container")
          .addClass("marge-mini");
      }
    }
  };

  /* L'indicateur de focus ne doit être visible que pour l'accessibilité */
  Drupal.behaviors.ramqFocusVisible = {
    attach: function (context) {
      $(
        ".page__content .liste-lien-action li, .tuile_service-principal",
        context
      ).on("focusin", function () {
        $(
          ".page__content .liste-lien-action li, .tuile_service-principal",
          context
        )
          .has("a.focus-visible")
          .css("box-shadow", "0 0 0 0.13rem #99B9E5");
      });

      $(
        ".page__content .liste-lien-action li, .tuile_service-principal",
        context
      )
        .has("a")
        .on("focusout", function () {
          $(this).css("box-shadow", "");
        });

      $("button.btn.btn-link.accordion", context).on("click", function () {
        $(this)
          .parents(".wp-block-accordion-accordion-block")
          .css("box-shadow", "");
      });
    }
  };

  //reset textfield for search box.
  Drupal.behaviors.ramqResetButton = {
    attach: function (context) {
      if (
        !!$("input[name=search]", context).length &&
        $("input[name=search]").val().length > 0
      )
        $(".button--reset").show();
      else $(".button--reset").hide();
      // $('.button--reset').hide();
      $("input[name=search]").on("keyup", function () {
        if ($(this).val().length > 0) $(".button--reset").show();
        else $(".button--reset").hide();
      });
      $(".button--reset").on("click", function () {
        var parent = $(this).closest("form");
        var classname = parent[0][0]["className"];
        parent[0][0]["value"] = "";
        $(".button--reset").hide();
      });
    }
  };

  // close colorbox button.
  Drupal.behaviors.ramqCloseColorbox = {
    attach: function (context) {
      $("#cboxFermer").on("click", function () {
        $("#cboxClose").trigger("click");
      });
    }
  };

  // Bloc Vos réponses :supprimez la cookie au clic du bouton recommencer.
  Drupal.behaviors.ramqDeleteCookies = {
    attach: function (context) {
      $(".assisted-navigation-message-block #recommencer").click(function () {
        cookies.get("message", null);
        $.removeCookie("message", {
          path: "/"
        });
        document.cookie = "message= ; expires = Thu, 01 Jan 1970 00:00:00 UTC";
      });
    }
  };

  /* Accessibilité - Ajout du title au iframe de la vidéo */
  Drupal.behaviors.ramqVideoAccessibility = {
    attach: function (context) {
      var videoTitle = $(".wp-block-embed-youtube")
        .find("figcaption")
        .text();
      $(".wp-block-embed-youtube")
        .find("iframe")
        .attr("title", videoTitle);
    }
  };

  Drupal.behaviors.ramqStylesInfobulles = {
    attach: function (context, settings) {
      $("#colorbox").on("click", function (event) {
        if (event.target.id == "colorbox") {
          $("#cboxClose").trigger("click");
        }
      });

      $("a[href^='/fr/definition'], a[href^='/en/definition']")
        .once()
        .append("<span class='sr-only'>-" + Drupal.t("Definition") + "</span>");

      var focusableElementsString =
        "a[href], button:not([disabled]), *[tabindex]";
      var focusedElementBeforeModal;

      // Gère le cycle de vie d'une lightbox
      $(document).on(
        "cbox_open cbox_closed cbox_complete cbox_cleanup",
        function (event) {
          switch (event.type) {
            case "cbox_open":
              focusedElementBeforeModal = $(":focus", context);
              $("body", context).addClass("mr15");
              $("body", context).css({
                overflow: "hidden"
              });
              $("#colorbox", context).off("keydown");
              $("#colorbox", context).on("keydown", function (evt) {
                trapTabKey($(this), evt);
              });
              if ($("#colorbox:not([aria-modal])", context).length) {
                $("#colorbox:not([aria-modal])", context).attr(
                  "aria-modal",
                  "true"
                );
              }
              break;
            case "cbox_complete":
              $("#colorbox div[class$='__node-title'] h2:not([id])", context).attr(
                "id",
                "modalTitle"
              );
              $("#colorbox", context).attr(
                "aria-labelledby",
                $("#colorbox div[class$='__node-title'] h2:not([id])").attr("id")
              );
              $("#colorbox:visible", context).trigger("focus");
              $("#cboxFermer", context).text(settings.colorbox.close);

              break;
            case "cbox_closed":
              $("body", context).removeClass("mr15");
              $("body", context).css({
                overflow: ""
              });
              $("#colorbox[aria-labelledby]", context).removeAttr(
                "aria-labelledby"
              );
              if (focusedElementBeforeModal) focusedElementBeforeModal.focus();
              break;
            case "cbox_cleanup":
              $("#colorbox", context).off("keydown");
              break;
          }
        }
      );

      $(window).on("resize", function () {
        Lightbox();
      });

      Lightbox();

      function Lightbox() {
        if ($("#main-content", context).length) {
          var blockContent = $("#main-content", context);
          $("body", context).css({
            "--block-content-width": blockContent.width() + "px"
          });
        }
      }

      // Gère la tabulation dans la lightbox
      function trapTabKey(obj, evt) {
        if (evt.which == 9) {
          var o = obj.find("*");
          var focusableItems;
          focusableItems = o.filter(focusableElementsString).filter(":visible");
          var focusedItem;
          focusedItem = $(":focus", context);
          var numberOfFocusableItems;
          numberOfFocusableItems = focusableItems.length;
          var focusedItemIndex;
          focusedItemIndex = focusableItems.index(focusedItem);
          if (evt.shiftKey) {
            if (focusedItemIndex == -1 || focusedItemIndex == 0) {
              focusableItems.get(numberOfFocusableItems - 1).focus();
              evt.preventDefault();
            }
          } else {
            if (
              focusedItemIndex == -1 ||
              focusedItemIndex == numberOfFocusableItems - 1
            ) {
              focusableItems.get(0).focus();
              evt.preventDefault();
            }
          }
        }
      }

      // Ajouter l'attribut aria-describedby d'une infobulle dans un webform (tippyjs)
      var tooltipId;
      $("span.webform-element-help", context).on(
        "focus mousemove click",
        function () {
          tooltipId = $("div[data-tippy-root]").attr("id");
          $(this).attr("aria-describedby", tooltipId);
        }
      );

      // Afficher/cacher le texte d'infobulle qui se trouve dans une page de contenu
      $(".infobulle-bloc .infobulle-bloc_texte").hide();
      $("span.infobulle-bloc", context).on("focus mouseenter", function () {
        var infobulleText = $(this).find(".infobulle-bloc_texte");
        infobulleText.stop(true).fadeTo(400, 1);

        //Vérifier si l'infobulle est hors écran
        //Scroller si c'est le cas
        var pageTop = $(window).scrollTop();
        var elementTop = infobulleText.offset().top;

        if (elementTop < pageTop) {
          $("html, body").animate({
            scrollTop: elementTop
          });
        }
      });
      $("span.infobulle-bloc, span.infobulle-bloc a", context).on(
        "blur mouseleave",
        function () {
          setTimeout(function () {
            //Vérifier si le focus ne s'est pas déplacé à l'intérieur de l'infobulle
            //Cacher l'infobulle, si ce n'est pas le cas
            if ($("span.infobulle-bloc").find(":focus").length == 0) {
              var infobulleText = $("span.infobulle-bloc").find(
                ".infobulle-bloc_texte"
              );
              infobulleText.fadeOut("400");
            }
          }, 10);
        }
      );
    }
  };

  //page loader for recherche de medicaments.
  Drupal.behaviors.pageloader = {
    attach: function (context) {
      $("#edit-submit-recherche-medicaments-page", context)
        .once("submit-recherche-medicaments-page")
        .each(function () {
          $(this).on("click", function () {
            $("#loader").css("display", "block");
            $(".loader-text")
              .append(Drupal.t("Your seach is in progress"))
              .css("display", "block");
          });

          if (param("m") != 0) {
            $(".result-header-count")
              .attr("tabindex", "-1")
              .on("focus");
          }

          function param(name) {
            var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
              window.location.href
            );
            if (results == null) {
              return null;
            }
            return decodeURI(results[1]) || 0;
          }
        });
    }
  };

  //translatable for auto complete suggestions available (use up and down arrow keys to navigate.)
  Drupal.behaviors.autocomplet = {
    attach: function (context) {
      if (!!$("#edit-m", context).length) {
        $("#edit-m", context)
          .once("autocomplete-messages")
          .autocomplete({
            messages: {
              noResults: Drupal.t("No results found."),
              results: function (amount) {
                return Drupal.t(
                  "@results results found, use up and down arrow keys to navigate.", {
                  "@results": amount
                }
                );
              }
            }
          });
      }
    }
  };

  // Ajouter la classe container sur les pages d'erreur
  // TODO: À enlever si une meilleure solution côté back-end existe
  Drupal.behaviors.addClassContainerToErrorPage = {
    attach: function (context) {
      $(context)
        .find("p.pages-erreur")
        .once("addClassContainerToErrorPage")
        .each(function () {
          $(this)
            .closest("div.page__content")
            .children("div:not(.container)")
            .first()
            .addClass("container");
        });
    }
  };

  // Faire fonctionner les accordéons avec Bootstrap 5
  Drupal.behaviors.accordeonToggleAttr = {
    attach: function (context) {
      $(".wp-block-accordion-accordion-block").once().each(function () {
        var button = $(this).find("button.accordion");
        if (button.attr("data-bs-toggle") == null) {
          var attrDataToggle = button.attr("data-toggle");
          var attrDataTarget = button.attr("data-target");
          button.attr("data-bs-toggle", attrDataToggle);
          button.attr("data-bs-target", attrDataTarget);
        }
      });
    }
  };

  // Faire fonctionner les accordéons indépendemment (groupes de tiroirs et tiroirs seuls)
  Drupal.behaviors.tiroirSeulVsGroupe = {
    attach: function (context) {
      $(".tiroir-seul").find(".collapse").attr("data-bs-parent", "");
      var groupeAccordeons = $(".groupe_accordeons");
      for (var i = 0; i < groupeAccordeons.length; i++) {
        var ele = groupeAccordeons[i];
        var id = ele.id;
        if (id === null || id === undefined || id === "") {
          $(ele).attr("id", `groupe-tiroir${i}`);
          id = ele.id;
        }
        $(ele).find(".collapse").attr("data-bs-parent", `#${id}`);
      }
    }
  };

  // Gestion code postal pour OpenStreetMap
  Drupal.behaviors.ramqPointsServiceOpenStreetMap = {
    attach: function (context) {
      $("#submit-btn-services-points", context)
        .click(function (event) {
          var codeOuVille = $("#edit-code-postal-ou-ville-source-configuration-origin-address", context).val();
          // Si second caractère est un chiffre => CP
          if (codeOuVille.trim() != "" && $.isNumeric(codeOuVille.charAt(1))) {
            var CP_REGEX = /[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]/;
            if (codeOuVille.trim().length == 6 && CP_REGEX.test(codeOuVille.trim())) {
              // H4HH5H => H4H H5H
              var cp = codeOuVille.substring(0, 3) + " " + codeOuVille.substring(3, 6);
              $("#edit-code-postal-ou-ville-source-configuration-origin-address", context).val(cp);
            }
          }
        });
    }
  };

  Drupal.behaviors.servicePointsAccordion = {
    attach: function (context) {
      $(".wp-block-group.groupe_accordeons.service_points_accordeons", context)
        .closest(".container")
        .removeClass("container");

      $(context)
        .find(
          ".service_points_accordeons .wp-block-group__inner-container > .row-contents > .views-row"
        )
        .once("servicePointsAccordion--1")
        .each(function () {
          $(this).addClass("wp-block-accordion-accordion-block");
        });

      $(
        ".service_points_accordeons .wp-block-group__inner-container > .row-contents > .views-row .btn.btn-link.accordion",
        context
      )
        .once("servicePointsAccordion--2")
        .click(function () {
          $(this).toggleClass("collapsed");
          $(this).attr(
            "aria-expanded",
            $(this).hasClass("collapsed") ? "false" : "true"
          );
          $(
            ".service_points_accordeons .wp-block-group__inner-container > .row-contents > .views-row .btn.btn-link.accordion",
            context
          )
            .not($(this))
            .addClass("collapsed");
          $(
            ".service_points_accordeons .wp-block-group__inner-container > .row-contents > .views-row .btn.btn-link.accordion",
            context
          )
            .not($(this))
            .attr("aria-expanded", "false");
          var $content = $(this)
            .parents(".header")
            .next();
          $(
            ".service_points_accordeons .wp-block-accordion-accordion-block .row-contents",
            context
          )
            .not($content)
            .slideUp(400);
          $content.slideToggle(400);
        });
    }
  };

  // React on hover of list of service points.
  Drupal.behaviors.geofieldMapLeafletMapInteraction = {
    attach: function attach(context, settings) {

      // La carte interactive n'étant pas accessible, il manque le texte d'avertissement la précédant.
      // Ceci est une exigence du SGQRI 008 2.0.
      var texteAvertissement = Drupal.t("The following content may not meet accessibility standards.");
      var htmlAvertissement = '<span id="avertissement_service-points-map" tabindex="0" class="visually-hidden focusable">' + texteAvertissement + '</span>'
      $('div[id^="leaflet-map-view-service-points-map-block-trouver-point-service"]').once().wrap("<div id='carte-points-services'></div>").before(htmlAvertissement);

      // Hide map on load.
      var url = document.location.href;
      if (
        url.search("code_postal_ou_ville") != -1 ||
        url.search("items_per_page") != -1
      ) {
        $("#carte-points-services").css(
          "display",
          "flex"
        );
        $("#views-exposed-form-service-points-map-block-trouver-point-service + .views-element-container, .node--type-service-points .views-element-container").css("display", "flex");

        if ($("#views-exposed-form-service-points-map-block-trouver-point-service").length) {
          $("html, body")
            .once()
            .animate({
              scrollTop: $(
                "#views-exposed-form-service-points-map-block-trouver-point-service"
              ).offset().top
            });
        }
      }

      var exposed = document.getElementById(
        "views-exposed-form-service-points-map-block-trouver-point-service"
      );
      if (exposed) {
        var body = document.body;
        body.classList.add("service_points_map_view");
      }

      /* Désactiver bouton UTILISER MA POSITION
       ** Fonctionne juste avec Chrome
       */
      var etatBoutonPosition = function (result) {
        if (result == "granted") {
          $("#edit-ma-position-button").attr("disabled", false);
          $("#edit-ma-position-button").removeClass("btn-disabled");
        } else if (result == "prompt") {
          $("#edit-ma-position-button").attr("disabled", false);
          $("#edit-ma-position-button").removeClass("btn-disabled");
        } else if (result == "denied") {
          $(
            "#views-exposed-form-service-points-map-service-points-map-page"
          ).addClass("position-blocked");
          $(".exposed_filter_or").attr("aria-hidden", true);
          $("#edit-ma-position-source-configuration-origin").attr({
            "aria-hidden": true,
            disabled: true
          });
          $("#edit-ma-position-button").addClass("btn-disabled");
          $("#edit-ma-position-button").attr({
            "aria-hidden": true,
            disabled: true
          });
        }
      };

      // Alternative à l'API de permission pour Safari, IE
      // Restreindre l'appel de la fonction à trouver un point de service
      if (
        window.location.pathname === "/fr/nous-joindre/trouver-point-service" ||
        window.location.pathname === "/en/contact-us/find-service-point"
      ) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            success => {
              etatBoutonPosition("granted");
            },
            error => {
              etatBoutonPosition("denied");
            }
          );
        }
      }

      // Fire submit when clicked on 'UTILISER MA POSITION'.
      $("#edit-ma-position-button", context).each(function () {
        $(this).on("click", function () {
          $(
            "#edit-code-postal-ou-ville-source-configuration-origin-address"
          ).val("");
          $(this)
            .closest("form")
            .trigger("submit");
        });
      });

      // ==========================================================
      // LOGIQUE D'INITIALISATION DE LA CARTE (EXTRAITE)
      // ==========================================================
      var initRamqMapLogic = function (lMap, mapid) {

        // Éviter l'exécution multiple sur la même carte
        var mapContainer = $(lMap.getContainer());
        if (mapContainer.hasClass('ramq-interaction-processed')) {
          return;
        }
        mapContainer.addClass('ramq-interaction-processed');

        var map = lMap;

        // Correction du zoom : Forcer le redimensionnement de la carte maintenant qu'elle est visible (display: flex)
        map.invalidateSize();

        if (!Drupal.Leaflet[mapid] || !Drupal.Leaflet[mapid].markers) {
          return;
        }

        var markers = Drupal.Leaflet[mapid].markers;
        var servicePointsArray = {};
        $(".service-points-list .marker-selector").each(function () {
          var title = $(this)
            .find("h2 button")
            .html()
            .trim();
          servicePointsArray[title] = title;
        });

        // Ajouter le marqueur central (Point de départ) s'il existe
        if (map.options.center) {
          L.marker(map.options.center).addTo(map);
        }

        // Appliquer le zoom (fitBounds) avec un léger délai pour s'assurer que le conteneur est prêt
        setTimeout(function () {
          var boundsArray = [];

          // Récupérer les coordonnées des marqueurs
          $.each(markers, function (key, marker) {
            if (marker._latlng) {
              boundsArray.push(marker._latlng);
            }
          });

          // Ajouter le centre aux limites
          if (map.options.center) {
            boundsArray.push(map.options.center);
          }

          if (boundsArray.length > 0) {
            map.invalidateSize(); // Sécurité supplémentaire
            map.fitBounds(boundsArray, { padding: [50, 50] });
          }
        }, 200);

        // --- Logique originale des clics et de l'interactivité ---

        var last_marker_id = -1;
        // On clicked on item list other "I".
        $(
          ".service-points-list .service-points-title-info-header .marker-selector",
          context
        ).each(function () {
          $(this).on("click", function (e) {
            // QUICK FIX : Ajouter "-0" au marker-id car les markers de Drupal.leaflet ont ce suffixe
            // Trouver une meilleure solution
            var marker_id = $(this).data("marker-id") + "-0";

            setTimeout(function () {
              if (markers[marker_id]) {
                if (last_marker_id !== marker_id) {
                  // Drupal.Leaflet.prototype.map_reset(mapid);
                  if (!markers[marker_id].getPopup().isOpen()) {
                    markers[marker_id].fire("click");
                    map.setView(markers[marker_id].getLatLng(), "12", {
                      animate: false
                    });
                  }
                  last_marker_id = marker_id;
                }
              }
            }, 500);
          });
        });

        // On click on "I".
        $(
          ".service-points-list .service-points-title-info-header .marker-selector .accordion-header",
          context
        ).each(function () {
          $(this).on("click", function () {
            var marker_id = $(this)
              .parent()
              .data("marker-id");
            setTimeout(function () {
              if (markers[marker_id]) {
                if (!markers[marker_id].getPopup().isOpen()) {
                  markers[marker_id].fire("click");
                }
                map.setView(markers[marker_id].getLatLng(), "15", {
                  animate: false
                });
              }
            }, 500);
          });
        });

        // React on click of marker pin.
        $(
          ".leaflet-container .leaflet-marker-pane .leaflet-marker-icon",
          context
        ).each(function () {
          $(this).on("click", function () {
            if ($(this).attr("title")) {
              var marker_title = $(this)
                .attr("title")
                .trim();
              if (servicePointsArray[marker_title]) {
                $(".service-points-list .item-list")
                  .find("li")
                  .each(function () {
                    var title = $(this)
                      .find(
                        ".service-points-title-info-header .service-points-title .marker-selector"
                      )
                      .attr("title");

                    if (title !== undefined) {
                      title = title.trim();
                      if (title === marker_title) {
                        var scrollTo = $(this).find(
                          ".service-points-title-info-header .service-points-title"
                        );
                        scrollTo.css("background", "#f2f1f1");
                        // Scroll to selected service points clicked pin
                        var container = $(".service-points-list").parent();
                        var position =
                          scrollTo.offset().top -
                          container.offset().top +
                          container.scrollTop();
                        container.animate({
                          scrollTop: position
                        },
                          500,
                          function () {
                            $(this)
                              .find(
                                ".service-points-title-info-header .accordion-header"
                              )
                              .each(function (key, value) {
                                if ($(this).hasClass("accordion-active")) {
                                  var grandParent = $(this).parentsUntil(
                                    ".service-points-title-info-header"
                                  )[2];
                                  var info = grandParent.nextElementSibling;
                                  this.classList.toggle("accordion-active");
                                  $(info).slideToggle("slow");
                                }
                              });
                          }
                        );
                      } else {
                        $(this)
                          .find(
                            ".service-points-title-info-header .service-points-title"
                          )
                          .css("background", "#ffffff");
                      }
                    }
                  });
              }
            }
          });
        });
      };

      // ==========================================================
      // EXÉCUTION DE LA LOGIQUE (SUPPORT POUR UTILISATEURS ANONYMES)
      // ==========================================================

      // 1. Écouter l'événement standard (Cas où le script charge AVANT la carte)
      $(document).on("leaflet.map", function (e, settings, lMap, mapid) {
        initRamqMapLogic(lMap, mapid);
      });

      // 2. Vérifier les cartes déjà existantes (Cas où le script charge APRÈS la carte - Mode Anonyme)
      if (Drupal.Leaflet) {
        $.each(Drupal.Leaflet, function (mapid, data) {
          if (data.lMap) {
            initRamqMapLogic(data.lMap, mapid);
          }
        });
      }

      // Accordions.
      $(
        ".service-points-list .service-points-title-info-header .accordion-header"
      )
        .once()
        .each(function () {
          $(this).on("click", function (item) {
            var grandParent = $(this).parentsUntil(
              ".service-points-title-info-header"
            )[2];
            var info = grandParent.nextElementSibling;
            var container = $(info).find(
              ".eva_content .views-element-container .jour-row"
            );
            if (container.length <= 0) {
              var heures = $(info).find(".heures-title");
              heures.css("display", "none");
            }
            this.classList.toggle("accordion-active");
            var scroll = $(window).scrollTop(); // Sauvegarder la position du scroll
            $(info).slideToggle("500", () => {
              // Hide all accordions before open the selected once.
              $(".service-points-list .item-list")
                .find("li")
                .each(function () {
                  $(this)
                    .find(".service-points-title-info-header .accordion-header")
                    .each(function (key, value) {
                      if (item.target !== value) {
                        if ($(this).hasClass("accordion-active")) {
                          var grandParent = $(this).parentsUntil(
                            ".service-points-title-info-header"
                          )[2];
                          var info = grandParent.nextElementSibling;
                          this.classList.toggle("accordion-active");
                          $(info).slideToggle("slow");
                        }
                      }
                    });
                });
            });
            // Corriger le problème de scroll dans chrome
            $("html, body").animate({
              scrollTop: scroll
            },
              500
            );

            if ($(this).hasClass("accordion-active")) {
              $(this).attr("aria-expanded", "true");
            } else {
              $(this).attr("aria-expanded", "false");
            }
          });
        });

      // On click other than "I".
      $(
        ".service-points-list .service-points-title-info-header .service-points-title"
      )
        .once()
        .click(function (item) {
          // Au clic des boutons des noms des établissements, ajouter rétroaction pour lecteur d'écran
          var title = $(this).find(".marker-selector").attr("title");
          var annonceTexte = Drupal.t("The facility % is located on the interactive map.");
          annonceTexte = annonceTexte.replace("%", title);
          var annonceHTML = '<div id="carte-points-services-annonce" aria-live="polite"></div>';

          if ($("#carte-points-services-annonce").length == 0) {
            $("body").append(annonceHTML);
          }
          $("#carte-points-services-annonce").html(annonceTexte);
          setTimeout(function () {
            $("#carte-points-services-annonce").html("");
          }, 4000);

          $(".service-points-list .item-list")
            .find("li")
            .each(function () {
              $(this)
                .find(".service-points-title-info-header .service-points-title")
                .css("background", "#ffffff");
            });
          $(this).css("background", "#f2f1f1");
          // Scroll selected  in to view.
          var container = $(".service-points-list").parent();
          var scrollTo = $(this);

          // Fermer l'accordéon déjà ouvert s'il y en a un
          if (
            $(".service-points-list .item-list")
              .children()
              .find(".accordion-active").length == 1
          ) {
            var accordeon_ouvert = $(".service-points-list .item-list")
              .children()
              .find(".accordion-active");
            var target_markerid = $(this)
              .children()
              .find(".marker-selector")
              .data("marker-id");

            // Si l'accordéon ouvert n'est pas celui qui vient d'être clické
            // Vérifier avec le marker-id
            if (target_markerid !== $(accordeon_ouvert).data("marker-id")) {
              var grandParent = $(accordeon_ouvert).parentsUntil(
                ".service-points-title-info-header"
              )[2];
              var info = grandParent.nextElementSibling;
              $(accordeon_ouvert).removeClass("accordion-active");
              $(info).slideUp("slow", function () {
                // scroller après la fermeture de l'accordéon
                var position =
                  scrollTo.offset().top -
                  container.offset().top +
                  container.scrollTop();
                container.animate({
                  scrollTop: position
                },
                  500
                );
              });
            } else {
              // scroller après l'ouverture' de l'accordéon
              var position =
                scrollTo.offset().top -
                container.offset().top +
                container.scrollTop();
              container.animate({
                scrollTop: position
              },
                500
              );
            }
          } else {
            // scroller après la fermeture de l'accordéon
            var position =
              scrollTo.offset().top -
              container.offset().top +
              container.scrollTop();
            container.animate({
              scrollTop: position
            },
              500
            );
          }
        });
    }
  };

  Drupal.behaviors.rechercheMedicamentsResultats = {
    attach: function (context) {
      var $text = $(
        ".page__content .recherche-medicaments-bloc #views-exposed-form-recherche-medicaments-page-medicaments-page .form-item-m input",
        context
      ).val();
      if (!$text || $text.length == 0) {
        $(
          ".page__content .recherche-medicaments-bloc > .aucun-resultat-recherche-med",
          context
        ).hide();
      }
    }
  };

  // Corrige des problèmes d'accessibilité soulevés par Patrick, au niveau de la barre de recherche globale
  // Voir le ticket #15153 sur Azure DevOps pour plus de détails
  Drupal.behaviors.fix15153DeplacerFocus = {
    attach: function (context) {
      $("button.searchbar-toggler", context).on("keydown", function (event) {
        if (
          !event.shiftKey &&
          event.which === 9 &&
          !$(this).hasClass("collapsed")
        ) {
          event.preventDefault();
          $("input#edit-search, input#edit-search--2", context).focus();
        }
      });
      $("input#edit-search, input#edit-search--2", context).on(
        "keydown",
        function (event) {
          if (event.shiftKey && event.which === 9) {
            event.preventDefault();
            $("button.searchbar-toggler", context).trigger("focus");
          }
        }
      );
      $(".searchbar-collapse #submit-btn", context).on("keydown", function (
        event
      ) {
        if (event.which === 9 && !event.shiftKey) {
          event.preventDefault();
          $(
            ".navbar-search-button-wrapper > .navbar-links-desktop > .block--navigationentete > ul.nav > li.nav-item:first-child > a.nav-link, .navbar-search-button-wrapper > .navbar-toggler",
            context
          ).trigger("focus");
        }
      });
      $(
        ".navbar-search-button-wrapper > .navbar-links-desktop > .block--navigationentete > ul.nav > li.nav-item:first-child > a.nav-link",
        context
      ).on("keydown", function (event) {
        if (
          event.which === 9 &&
          event.shiftKey &&
          !!$(".searchbar-collapse.show #submit-btn", context).length
        ) {
          event.preventDefault();
          $(".searchbar-collapse.show #submit-btn", context).trigger("focus");
        }
      });
      $(".navbar-search-button-wrapper > .navbar-toggler", context).on(
        "keydown",
        function (event) {
          if (
            event.which === 9 &&
            !event.shiftKey &&
            !!$(
              ".searchbar-collapse.show #edit-search, .searchbar-collapse.show #edit-search--2",
              context
            ).length
          ) {
            event.preventDefault();
            if ($(this).hasClass("collapsed"))
              $(context)
                .find("main#main-content a[href]")
                .first()
                .trigger("focus");
            else
              $(
                ".navbar-collapse.show > .navbar-links-mobile > .navbar_links .block--navigationentete > ul.nav > li.nav-item:first-child > a.nav-link",
                context
              ).trigger("focus");
          }
        }
      );
      $(
        ".navbar-collapse > .navbar-links-mobile > .navbar_links .block--navigationentete > ul.nav > li.nav-item:first-child > a.nav-link",
        context
      ).on("keydown", function (event) {
        if (
          event.which === 9 &&
          event.shiftKey &&
          !!$(
            ".searchbar-collapse.show #edit-search, .searchbar-collapse.show #edit-search--2",
            context
          ).length
        ) {
          event.preventDefault();
          $(".navbar-search-button-wrapper > .navbar-toggler", context).trigger(
            "focus"
          );
        }
      });
      $("main#main-content a[href]", context)
        .first()
        .on("keydown", function (event) {
          if (
            event.which === 9 &&
            event.shiftKey &&
            !!$(".searchbar-collapse.show #submit-btn", context).length
          ) {
            event.preventDefault();
            $(
              ".navbar-search-button-wrapper > .navbar-toggler.collapsed",
              context
            ).trigger("focus");
          }
        });
      $(".navbar-search-button-wrapper > .navbar-toggler.collapsed", context)
        .first()
        .on("keydown", function (event) {
          if (
            event.which === 9 &&
            event.shiftKey &&
            !!$(".searchbar-collapse.show #submit-btn", context).length
          ) {
            event.preventDefault();
            $(".searchbar-collapse.show #submit-btn", context).trigger("focus");
          }
        });
      $(
        ".navbar-search-button-wrapper > .navbar-links-desktop > .block--navigationentete > ul.nav > li.nav-item:last-child > a.nav-link",
        context
      ).on("keydown", function (event) {
        if (
          event.which === 9 &&
          !event.shiftKey &&
          !!$(
            ".searchbar-collapse.show #edit-search, .searchbar-collapse.show #edit-search--2",
            context
          ).length
        ) {
          event.preventDefault();
          $(
            ".page__menu > .block--navigationprincipale > ul.nav > li.nav-item:first-child > a.nav-link",
            context
          ).trigger("focus");
        }
      });
      $(
        ".page__menu > .block--navigationprincipale > ul.nav > li.nav-item:first-child > a.nav-link",
        context
      ).on("keydown", function (event) {
        if (
          event.which === 9 &&
          event.shiftKey &&
          !!$(
            ".searchbar-collapse.show #edit-search, .searchbar-collapse.show #edit-search--2",
            context
          ).length
        ) {
          event.preventDefault();
          $(
            ".navbar-search-button-wrapper > .navbar-links-desktop > .block--navigationentete > ul.nav > li.nav-item:last-child > a.nav-link",
            context
          ).trigger("focus");
        }
      });
    }
  };

  // Gère le focus de la barre de défilement horizontal au niveau du carrousel slick
  Drupal.behaviors.CarrouselSlick = {
    attach: function (context) {
      $("#slick-views-evenements-de-vie-block-1-1-slider", context).on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          $(slick.$dots[0].children[nextSlide])
            .find("button")
            .first()
            .trigger("focus");
        }
      );
    }
  };

  /* Ajustements visuels au Guide UI inaccessibles en css
   */
  Drupal.behaviors.guideUIAjustementsVisuels = {
    attach: function (context) {
      //Si le groupe contenu-page est coupé par un groupe guide-ui_demo
      //il faut enlever le margin-bottom au groupe contenu-page
      $(context)
        .find(".guide-ui_demo")
        .prev(".contenu-page")
        .each(function () {
          $(this).css("margin-bottom", "0");
        });

      // DÉMO AVIS EN ENTÊTE
      $(context)
        .find(".guide-ui_demo .close-block.block")
        .css("display", "block");
      $(context)
        .find(".guide-ui_demo .close-block.block button.closeblock-button")
        .attr("disabled", "true");
    }
  };

  // annuler l'affichage d'un attribut title au survol d'un lien
  Drupal.behaviors.removdataentityuuid = {
    attach: function (context) {
      // Supprimez l'attribut data-entity-uuid de toutes les balises HTML
      $("[data-entity-uuid]").removeAttr("data-entity-uuid");
      $("a").removeAttr("title");
    }
  }


  // correction de bug à la version en, consigne ne s'aplique pas
  Drupal.behaviors.bugConsigneEN = {
    attach: function (context) {

      $("#edit-markup-indication p").contents().unwrap();

    }
  }

  // Fix button Backtotop lors du passage à Drupal 10.5
  Drupal.behaviors.backtotopFix = {
    attach: function (context) {
      once('backtotopFix', '#backtotop', context).forEach((btn) => {
        if (!btn.querySelector('span.sr-only')) {
          // Crée le span manquant (comme dans D10.3)
          const span = document.createElement('span');
          span.classList.add('sr-only');
          span.textContent = 'Retour en haut de page';
          btn.textContent = '';
          btn.appendChild(span);
          btn.style.padding = '0';
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
